// Ambiente "development" para SWA: apunta al backend de QA como base.
// TODO: reemplazar `server` por la URL HTTPS confirmada del backend DEV
// (pendiente con DevOps/backend — ver migration-plan.html).

export const environment = {
  production: false,
  server: 'http://10.170.2.22:8080/',
  app: "back-restitucion/",
  api: 'restitucion/',
  api_recaptcha: 'recaptcha/',
  api_identidad: 'identidad/',
  recaptcha: {
    siteKeyV3: '6LeuZZ8aAAAAACXFcwDldF1aTpiWk3F40LbKTiV1',
    siteKeyV2: '6LcfChoUAAAAAByj6ncOd5NMwDb39no0LFuCYLDN'
  },
  featureFlags: {
    prontoPagoRestitucion: true
  },
  iframe: {
    origenPadre: 'http://10.170.2.6/consulta-restitucion-ley-corta/'
  }
};
